import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LegalBasis3BasicRolandDe } from '@flows/insurance/schemas'

const legal_claims_free = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('number_of_years_claims_free')]:
        BaseSchema_LegalBasis3BasicRolandDe.shape.number_of_years_claims_free.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.legal_3.claims_free.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('number_of_years_claims_free'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:steps.legal_3.claims_free.0',
            },
            value: '0',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:steps.legal_3.claims_free.1',
            },
            value: '1',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:steps.legal_3.claims_free.2',
            },
            value: '2',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:steps.legal_3.claims_free.3',
            },
            value: '3',
          },
        ],
      },
      {
        type: 'infoBox',
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_legal:steps.legal_3.claims_free.infoText',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: 'legal_damages',
  }) as const satisfies AnyStepConfiguration

export default legal_claims_free
